<template>
  <div id="sign-up-b2b-view">
    <div id="join-b2b-form" data-testid="tabs-sign-up-b2b" class="tabs-container col-12 px-5 pt-5 ">
      <button
        v-for="({ title, data }, index) in tabs"
        :key="title"
        :class="[
          selectedTab === index
            ? 'tab__active active'
            : `tab__disabled ${data ? 'tab-border__fill' : 'tab-border__disabled'}`,
          'normal'
        ]"
        :data-testid="`${title}-tabs-sign-up-b2b`"
      >
        <div :class="selectedTab === index ? 'number__active' : 'number__disabled'">
          <span v-if="selectedTab === index || !data" class="number__index">{{ index + 1 }}</span>
          <i v-else class="icon-ok-tick-filled sm black" />
        </div>

        <span
          :class="
            selectedTab === index
              ? 'title-tab__active'
              : `title-tab__disabled ${data ? 'black' : ''}`
          "
          :data-testid="`profile-tab`"
        >
          {{ title }}
        </span>
      </button>
    </div>
    <transition mode="out-in" name="slide-right">
      <keep-alive>
      <Step1 v-if="selectedTab === 0" @next="onNext" />
      <Step2TravelAgent
        v-else-if="selectedTab === 1 && iata"
        :iata="iata"
        :memberType="memberType"
        :loading="loading"
        :selectedCountry="selectedCountry"
        @submitTA="onSubmit"
        :isChina="isChina"
      />
      <Step2MeetingPlanner
        v-else-if="selectedTab === 1 && !iata"
        :selectedCountry="selectedCountry"
        @submitMP="onSubmit"
        :loading="loading"
        :isChina="isChina"
      />
    </keep-alive>
    </transition>
  </div>
</template>

<script>
import Step1 from '../components/nlp-signup-b2b/Step1.vue'
import Step2TravelAgent from '../components/nlp-signup-b2b/Step2TravelAgent.vue'
import Step2MeetingPlanner from '../components/nlp-signup-b2b/Step2MeetingPlanner.vue'
import { loyaltyService } from '../infrastructure/Factory'
import { getPageLanguage, showModalRewardsLoginOnEmailAlreadyUsedError } from '@/infrastructure/Utils'
import { userTypes, OcicoUpsellEmailConsents, OcicoWhatsAppConsent } from '@/infrastructure/Configuration'
import { mapActions } from 'vuex'
import getUrlsParams from '@/components/mixins/getUrlParams'

export default {
  name: 'Tabs',
  components: {
    Step1,
    Step2TravelAgent,
    Step2MeetingPlanner
  },
  props: {
    isChina: Boolean
  },
  mixins: [getUrlsParams],
  data() {
    return {
      selectedTab: 0,
      iata: '',
      selectedCountry: '',
      tabs: [
        { title: this.translate('rwYourDetails'), data: '' },
        { title: this.translate('rwProfessionalInformation'), data: '' }
      ],
      memberType: '',
      loading: false,
      success: false,
      isOcicoUpsellConsentFF: global.ConfigDynamic.isEnabled(global.ConfigDynamicKey.BOOKING_CICO_UPSELLING_CONSENT)
    }
  },
  mounted() {
    addEventListener('beforeunload', () => {
      if (!this.success) {
        this.trackEvent({
          eventName: 'FORM_ABANDONMENT',
          eventData: {
            formName: 'rewards_join_b2b_form'
          }
        })
      }
    })
  },
  methods: {
    ...mapActions(['trackEvent', 'trackErrorEventB2BEnrollment']),
    changeTab(tab) {
      this.selectedTab = tab
    },
    async onNext(event) {
      const { meetingPlanner, travelAgent, iata } = event
      this.memberType = this.getUserType(meetingPlanner, travelAgent, iata)
      this.iata = iata || ''
      this.selectedTab = 1
      this.tabs[0].data = event
      this.selectedCountry = event?.business?.countryCode

      document.getElementById('join-b2b-form').scrollIntoView({ behavior: 'smooth' })
    },

    async onSubmit(event) {
      if (this.loading) {
        return
      }
      try {
        const { marketingEmailsConsent, privacyPolicy, termsAndConditions } = event?.customer
        let businessSignUpRequestBody = {
          business: {
            ...this.tabs[0].data.business,
            ...event,
            marketingEmailsConsent,
            privacyPolicy,
            termsAndConditions,
            type: this.memberType
          }
        }
        this.loading = true
        businessSignUpRequestBody = this.isOcicoUpsellConsentFF ? this.addEmailOcicoUpsellConsents(businessSignUpRequestBody) : businessSignUpRequestBody
        if (this.originPropertyId) {
          businessSignUpRequestBody.business.originPropertyId = this.originPropertyId
        }
        if (this.employeeCode) {
          businessSignUpRequestBody.business.employeeId = this.employeeCode
        }

        businessSignUpRequestBody.business = global.UtilsText.parseTextFromStringObject(businessSignUpRequestBody.business)

        await loyaltyService.signUpB2b(businessSignUpRequestBody)
        this.$store.dispatch('trackEvent', {
          eventName: 'IS_SIGNUP_B2B',
          eventData: {
            isSignupRewards: true
          }
        })
        this.trackEvent({
          eventName: 'FORM_SUBMISSION',
          eventData: {
            formUserCountry: businessSignUpRequestBody.business.countryCode,
            formName: 'rewards_join_b2b_form',
            formB2bUserType: businessSignUpRequestBody.business.type
          }
        })
        const showB2bDataGathering = '?displayDataGathering=true'
        this.success = true
        global.AuthDispatcher.login(
          null,
          `/${getPageLanguage().toLowerCase()}/radisson-rewards/secure/my-account${showB2bDataGathering}`
        )
      } catch (error) {
        console.error(error)
        const err = Object.assign({}, error.response?.data, { status: error.response?.status })
        if (error.response && error.response.status === 409) {
          showModalRewardsLoginOnEmailAlreadyUsedError(this.tabs[0].data.business.email)
          this.selectedTab = 0
        } else {
          global.ApiHandlers.handleErrorsMessage(err)
        }
        this.trackErrorEventB2BEnrollment({ error: err, isParsed: true })
        this.loading = false
      }
    },
    getUserType(meetingPlanner, travelAgent, iata) {
      let userType = ''
      if (iata && travelAgent && meetingPlanner) {
        userType = userTypes.TRAVEL_AGENT_MEETINGS_AND_EVENTS
      } else if (iata && travelAgent && !meetingPlanner) {
        userType = userTypes.TRAVEL_AGENT
      } else if (!iata && travelAgent && !meetingPlanner) {
        userType = userTypes.TRAVEL_ARRENGER
      } else if (!iata && !travelAgent && meetingPlanner) {
        userType = userTypes.MEETINGS_AND_EVENTS
      } else if (!iata && travelAgent && meetingPlanner) {
        userType = userTypes.TRAVEL_ARRENGER_MEETINGS_AND_EVENTS
      } else {
        userType = userTypes.TRAVEL_ARRENGER
      }
      return userType
    },
    addWhatsAppOcicoConsents(businessSignUpRequestBody) {
      OcicoWhatsAppConsent.forEach(consentType => {
        businessSignUpRequestBody.business = { ...businessSignUpRequestBody.business, [consentType]: businessSignUpRequestBody.business.telephone.number !== '' }
      })

      return businessSignUpRequestBody
    },
    addEmailOcicoUpsellConsents(businessSignUpRequestBody) {
      this.addWhatsAppOcicoConsents(businessSignUpRequestBody)
      OcicoUpsellEmailConsents.forEach(consentType => {
        businessSignUpRequestBody.business = { ...businessSignUpRequestBody.business, [consentType]: true }
      })
      return businessSignUpRequestBody
    }
  }
}
</script>

<style scoped lang="scss">
.tabs-container {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 2.5rem;
  gap: 1rem;
  button {
    display: flex;
    align-items: center;
    gap: 2rem;
    border-top: 0 solid transparent;
    border-left: 0 solid transparent;
    border-right: 0 solid transparent;
    font-weight: 400;
    padding: 0.625rem;
    padding-left: 0;
    background: color('white');
    color: color('dark-grey');

    &:focus {
      outline: none;
      box-shadow: none;
    }
  }
  button.active {
    border-bottom: 2px solid color('rhg-red');
    color: color('black');
  }
}

.number {
  &__active {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.25rem;
    gap: 0.625rem;

    width: 2.5rem;
    height: 2.5rem;

    background: color('rhg-red');
    border-radius: 40px;
  }
  &__disabled {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.25rem;
    gap: 0.625rem;
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 40px;
    background: color('white');
  }
  &__index {
    color: color('white');
  }
}

.tab {
  &__active {
    display: flex;
    align-items: center;
    gap: 1rem;
    width: 100%;
  }
  &__disabled {
    width: 100%;
    @media (max-width: media('mobile-l')) {
      width: unset;
    }
  }
}
.title-tab {
  &__active {
    font-style: normal;
    font-weight: 600;
    font-size: 1.375rem;
    line-height: 1.5rem;
    letter-spacing: 0.138462px;
  }
  &__disabled {
    font-style: normal;
    font-weight: 400;
    font-size: 1.375rem;
    line-height: 1.5rem;
    letter-spacing: 0.138462px;
    color: color('grey');
    @media (max-width: media('mobile-l')) {
      display: none;
    }
  }
}
.slide-right-enter-active,
.slide-right-leave-active {
  transition: all 0.8s;
}

.slide-right-enter {
  opacity: 0;
  transform: translateX(100px);
}

.slide-right-leave-to {
  transform: translateX(-100px);
  opacity: 0;
}
.black {
  font-style: normal;
  font-weight: 400;
  font-size: 1.375rem;
  line-height: 1.5rem;
  letter-spacing: 0.138462px;
  color: black;
}

.tab-border {
  &__fill {
    border-bottom: 2px solid black;
  }
  &__disabled {
    border-bottom: 2px solid #d8d8d8;
  }
}
.normal {
  cursor: default;
}
</style>
